import { FC } from 'react'

export interface ArrowProps {

}

export const Arrow: FC<ArrowProps> = (props) => {

    return (
        <svg width="42" height="19" viewBox="0 0 42 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="8" width="34" height="19" fill="#E9E9E9" />
            <path d="M0.5 9.5H24.5M24.5 9.5L17.5 2.5M24.5 9.5L17.5 16.5" stroke="#244D4D" strokeWidth="1.5" />
        </svg>

    )
}